<div class="flex items-center justify-center h-screen">
  <form #loginForm="ngForm" (ngSubmit)="login(loginForm)">
    <p class="text-2xl">Login</p>
    @if (invalidLogin) {
      <div i18n>Invalid username or password.</div>
    }
    <br />
    <label for="username" class="mr-4" i18n>User Name:</label>
    <input
      class="mb-2"
      type="email"
      id="username"
      name="email"
      [(ngModel)]="credentials.email"
      placeholder="email"
      required
    />
    <br />
    <label for="password" class="mr-4" i18n>Password:</label>
    <input
      type="password"
      id="password"
      name="password"
      [(ngModel)]="credentials.password"
      placeholder="Password"
      required
    />
    <br />
    <button
      type="submit"
      [disabled]="!loginForm.valid"
      class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mt-8"
    >
      Log in
    </button>
  </form>
</div>
